import { DATE_FORMAT_RU } from 'constants/date';
import { MilitaryClass } from 'types';

import { getFormattedDate } from 'utils';

import { SubParentTypes } from './types';

export const getSubParentName = (
  subParentType: string | undefined,
  type: string
) =>
  (subParentType === SubParentTypes.TYPE && type) ||
  (subParentType === SubParentTypes.DATE &&
    getFormattedDate(new Date(), DATE_FORMAT_RU)) ||
  (subParentType === SubParentTypes.NONE && 'DATE' && null) ||
  null;

export const extractIcons = (icons: MilitaryClass[]): MilitaryClass[] =>
  icons.flatMap((icon) =>
    icon.Children ? [icon, ...extractIcons(icon.Children)] : icon
  );
